/**
 * Shared formatting for Stripe-backed pricing plans (getPricingPlans).
 */

export function formatPrice(unitAmount: number, currency: string): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(unitAmount / 100);
}
